export function productAnimation() {
    const $window = window;
    let pageTitle;
    let canvasForScrollHolder;
    let productAnimationHolder;
    let productNextHolder;
    let contentRow;
    let mediaHolder;
    let productNextHolderContainer;
    let transformCoefficient;
    let scrollTop;
    let sectionOffset;
    let maxScrollTop
    let pagePattern = document.querySelector(".wrapper > .pattern");
    let canvasWidth;
    let canvasHeight;
    pagePattern.classList.add("sticky");
    pageTitle = document.querySelector(".page-title");
    canvasForScrollHolder = document.querySelector(".product-animation-holder");
    canvasForScrollHolder.classList.remove("indent-bottom");
    if (canvasForScrollHolder.classList.contains("with-next-block")) {
        let originalProductAnimation = canvasForScrollHolder.outerHTML;
        let originalProductAnimationNextBlock = canvasForScrollHolder.nextElementSibling;
        originalProductAnimationNextBlock.classList.add("product-next-block");
        originalProductAnimationNextBlock.classList.remove("indent-bottom");
        let originalProductAnimationNextBlockHTML = originalProductAnimationNextBlock.outerHTML;
        originalProductAnimationNextBlock.remove();
        canvasForScrollHolder.outerHTML = "<div class='product-animation-wrapper indent-bottom'>" + originalProductAnimation + originalProductAnimationNextBlockHTML + "</div>";
        canvasForScrollHolder = document.querySelector(".product-animation-wrapper");
        productNextHolder = document.querySelector(".product-next-block");
        productAnimationHolder = document.querySelector(".product-animation-holder");
        contentRow = productNextHolder.querySelector(".content-row");
        mediaHolder = productNextHolder.querySelector(".media-holder");
        productNextHolderContainer = productNextHolder.querySelector(".main-container");
        pageTitle.style.marginBottom = -pageTitle.clientHeight / 3 + "px";
        if ($window.innerWidth < 1200 && $window.innerHeight < 600) {
            canvasForScrollHolder.style.minHeight = (productNextHolder.clientHeight + $window.innerHeight * 2.5 + 200) + 'px';
            productNextHolder.style.marginTop = -productNextHolder.clientHeight + "px";
            pageTitle.style.marginBottom = -50  + "px";
        } else {
            canvasForScrollHolder.removeAttribute("style");
            productNextHolder.removeAttribute("style");
            pageTitle.style.marginBottom = -pageTitle.clientHeight / 4.5 + "px";
        }
    }
    const productAnimation = document.querySelector(".product-animation-box");
    const canvasForScroll = document.getElementById("product-animation");
    const contextForScroll = canvasForScroll.getContext("2d");
    let filesForScroll;

    $window.onbeforeunload = function () {
        window.scrollTo(0, 0);
    }
    if ($window.innerWidth < 1200) {
        // canvasWidth = 960;
        // canvasHeight = 540;
        // filesForScroll = canvasForScroll.dataset.directoryMobileUrl;
        canvasWidth = 1920;
        canvasHeight = 1080;
        filesForScroll = canvasForScroll.dataset.directoryUrl;
    } else {
        canvasWidth = 1920;
        canvasHeight = 1080;
        filesForScroll = canvasForScroll.dataset.directoryUrl;
    }
    canvasForScroll.width = canvasWidth;
    canvasForScroll.height = canvasHeight;
    const currentFrameForScroll = index => (`${filesForScroll}/${(index / 100000).toFixed(5).toString().slice(2).padStart(0)}.webp`);
    const frameCountForScroll = 60;
    const imagesForScroll = [];
    const preloadimagesForScrollForScroll = () => {
        for (let i = 0; i <= frameCountForScroll; i++) {
            imagesForScroll[i] = new Image();
            imagesForScroll[i].src = currentFrameForScroll(i);
        }
    };
    preloadimagesForScrollForScroll();

    const imgForScroll = new Image();
    imgForScroll.src = currentFrameForScroll(0);
    imgForScroll.onload = function () {
        contextForScroll.drawImage(imgForScroll, 0, 0);
    };
    window.addEventListener("resize", () => {
        if ($window.innerWidth >= 1200) {
            setTimeout(function () {
                pageTitle.style.marginBottom = -pageTitle.clientHeight / 4.5 + "px";
            }, 350);
        }
    });
    window.addEventListener("orientationchange", () => {
        if ($window.innerWidth < 1200 && $window.innerHeight < 600) {
            canvasForScrollHolder.style.minHeight = (productNextHolder.clientHeight + $window.innerHeight * 2.5 + 200) + 'px';
            productNextHolder.style.marginTop = -productNextHolder.clientHeight + "px";
            setTimeout(function () {
                pageTitle.style.marginBottom = -50 + "px";
            }, 350);
        } else {
            canvasForScrollHolder.removeAttribute("style");
            productNextHolder.removeAttribute("style");
        }
    });
    window.addEventListener("scroll", () => {
        scrollTop = window.scrollY;
        sectionOffset = canvasForScrollHolder.offsetTop;
        maxScrollTop = $window.innerHeight * 2.3;
        if (scrollTop > sectionOffset && scrollTop < sectionOffset + (maxScrollTop / 2)) {
            const scrollFraction = (scrollTop - sectionOffset) / (maxScrollTop / 2);
            const frameIndex = Math.min(frameCountForScroll, Math.floor(scrollFraction * frameCountForScroll));
            requestAnimationFrame(() => {
                contextForScroll.clearRect(0, 0, canvasForScroll.width, canvasForScroll.height);
                contextForScroll.drawImage(imagesForScroll[frameIndex + 1], 0, 0);
            });
        }
        if (scrollTop < sectionOffset) {
            contextForScroll.clearRect(0, 0, canvasForScroll.width, canvasForScroll.height);
            contextForScroll.drawImage(imagesForScroll[1], 0, 0);
        }
        if (scrollTop > sectionOffset + maxScrollTop) {
            contextForScroll.clearRect(0, 0, canvasForScroll.width, canvasForScroll.height);
            contextForScroll.drawImage(imagesForScroll[frameCountForScroll], 0, 0);
        }
        transformCoefficient = (contentRow.offsetTop - productNextHolderContainer.offsetTop) + (contentRow.clientHeight + 60) + (mediaHolder.clientHeight / 2);
        if (scrollTop > sectionOffset + $window.innerHeight) {
            pagePattern.classList.add("hide");
            canvasForScrollHolder.classList.add("animate");
            productAnimationHolder.style.height = productNextHolder.clientHeight + "px";
            productAnimation.style.transform = "translateY(" + transformCoefficient + "px)";
        } else {
            pagePattern.classList.remove("hide");
            canvasForScrollHolder.classList.remove("animate");
            productAnimationHolder.style.height = $window.innerHeight + "px";
            productAnimation.style.transform = "translateY(0px)";
        }
    });

}


// WEBPACK FOOTER //
// ./assets/js/modules/productAnimations.js